import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IHAL, IURLParams, IDefaultObject } from './crud.model';
import { environment } from 'src/environments/environment';

export class keyNotExistInMap extends ReferenceError { }

@Injectable({
	providedIn: "root"
})
export abstract class CRUDService {
	protected baseUrl: string = environment.baseUrl;

	protected httpOptions = {
		headers: new HttpHeaders({
			// 'Content-Type': 'application/json',
			'Content-Type': 'multipart/form-data',
		})
	};
	protected httpFileOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'multipart/form-data',
		})
	};
	protected map: Map<string, Object> = new Map<string, Object>();

	constructor(protected _http: HttpClient) { }

	protected find(url: string, params: IURLParams, qFilter?: any) {
		return this._getHttp(this._makeUrl(url, params, null, qFilter));
	}

	private _resolveMapKey(id: number | string, type: string) {
		return id + '-' + type;
	}

	get(key: string, url: string, params: IURLParams, keepInMap: boolean = true, getCopy: boolean = true, qFilter?: any): Observable<IHAL> {
		url = this._makeUrl(url, params, key, qFilter);

		let mapKey = this._resolveMapKey(key, params.c);

		if (!this._checkIfExistInMap(mapKey)) {
			return this._getFromHttp(url, keepInMap, getCopy, mapKey);
		} else {
			let obj = this.getFromMap(mapKey);
			if (params.d != undefined && params.d > (<IDefaultObject>obj).d) {
				return this._getFromHttp(url, keepInMap, getCopy, mapKey);
			} else {
				return of(<IHAL>obj);
			}
		}
	}
	create(url: string, params: IURLParams, body: any | null, options = this.httpOptions): Observable<IHAL> {
		url = this._makeUrl(url, params);
		return this._http.post<IHAL>(url, body, options).pipe(
			tap(
				r => { return body }
			)
		);
	}
	update(url: string, id: string, body: any | null, c?: string, options = this.httpOptions): Observable<any> {
		url = this._makeUrl(url, { c: c }, id)
		let key = body.cid

		if (typeof key == 'number')
			key = key.toString()

		let mapKey = this._resolveMapKey(key, c);

		return this._http.put<IHAL>(url, body, options)
			.pipe(
				tap(x => {
					if (this._checkIfExistInMap(mapKey)) {
						let obj = this.getFromMap(mapKey);
						if (body.d != undefined && body.d < (<IDefaultObject>obj).d) {
							body = Object.assign(obj, body)
						}
						this.setToMap(mapKey, body);
					}
				})
			)
	}
	delete(url: string, id: string, c: string, options = this.httpOptions): Observable<IHAL | string> {
		url = this._makeUrl(url, { c: c }, id)
		return this._http.delete<IHAL>(url, options)
	}
	uploadFile(file: File): Observable<any> {
		let formData = new FormData();
		formData.append("file", file, file.name);
		return this._http.post<any>('api/data/import', file, this.httpFileOptions);
	}

	protected getFromMap(key: string) {
		return this.map.get(key);
	}
	protected setToMap(key: string, value: Object) {
		this.map.set(key, value);
	}
	private _makeUrl(url: string, params?: IURLParams, key?: string, qFilter?: any) {
		if (url != undefined) {
			let sep = '?';
			if (key) {
				sep = '&'
			}
			url = (url.search("/") == 0 ? url.substring(1) : url)
			url = (url.search("http") < 0 ? `${this.baseUrl}/${url}` : url)
			url = (key
				// && url.search(key) < 0
				? `${url}?id=${key}` : url)
			url = (params ? `${url}${sep}${this._resolveUrlParams(params)}` : url)
			url = (qFilter && params != null ? `${url}&q=${JSON.stringify(qFilter)}` : url)
		} else {
			url = this.baseUrl
		}
		return url
	}
	private _getFromHttp(url: string, keepInMap: boolean = true, getCopy: boolean, mapKey: string) {
		return this._getHttp(`${url}`)
			.pipe(
				tap(res => {
					if (keepInMap)
						this.setToMap(mapKey, res)
				}),
				tap(res => {
					if (getCopy) {
						res = JSON.parse(JSON.stringify(res))
						return res
					}
				})
			)
	}
	private _getHttp(url: string, options = this.httpOptions) {
		return this._http.get<IHAL>(url, options);
	}
	private _checkIfExistInMap(key: string): boolean {
		return this.map.has(key);
	}
	private _resolveUrlParams(params: IURLParams) {
		(params.d === undefined ? params.d = 50 : '');

		return `${JSON.stringify(params)
			.replace(/\{/g, '')
			.replace(/\}/g, '')
			.replace(/\"/g, '')
			.replace(/\:/g, '=')
			.replace(/\,/g, '&')}`;
	}
}
